module.exports = __webpack_public_path__ + "img/image-train.e634e029.png";